import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/appstore_badge.svg'
import _imports_1 from '@/assets/images/playstore_badge.svg'
import _imports_2 from '@/assets/images/countdown.gif'
import _imports_3 from '@/assets/images/editwork.jpg'
import _imports_4 from '@/assets/images/laurel.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "home-bg" }, null, -1)
const _hoisted_3 = { class: "home-content" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"row justify-content-center linkbadge-wrapper\"><a class=\"col-8 col-sm-5 col-md-4 col-lg-3 col-xl-2\" href=\"https://apps.apple.com/us/app/big-timer-interval-clock/id1522536309?platform=iphone\" target=\"_blank\"><img class=\"linkbadge\" src=\"" + _imports_0 + "\"></a><a class=\"col-8 col-sm-5 col-md-4 col-lg-3 col-xl-2\" href=\"https://play.google.com/store/apps/details?id=at.seemayr.bigtimer\" target=\"_blank\"><img class=\"linkbadge\" src=\"" + _imports_1 + "\"></a></div>", 1)
const _hoisted_5 = {
  class: "row justify-content-center",
  id: "more-info"
}
const _hoisted_6 = { class: "col-11 col-md-8" }
const _hoisted_7 = { class: "row info-section justify-content-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "col-11 col-md-6 screenshot"
}, null, -1)
const _hoisted_9 = { class: "col-11 col-md-6 screenshot-text-container" }
const _hoisted_10 = { class: "screenshot-text-wrapper-left" }
const _hoisted_11 = { class: "screenshot-text" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Vibrant colors. Huge digits.")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Turn your phone into the ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" interval timer. ")
const _hoisted_16 = { class: "row info-section justify-content-center" }
const _hoisted_17 = { class: "col-11 col-md-6 screenshot-text-container" }
const _hoisted_18 = { class: "screenshot-text-wrapper-right" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Flexible")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("made simple")
const _hoisted_22 = [
  _hoisted_19,
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "screenshot-text" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Create and store ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" interval sets.")
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Add one ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" cycles to your set.")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Configure ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" of a cycle.")
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Nevermind. Just try it. ")
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "✌", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "col-11 col-md-6 screenshot"
}, null, -1)
const _hoisted_36 = { class: "row justify-content-center info-section" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "col-8 col-md-5 col-xl-3 info-icon"
}, null, -1)
const _hoisted_38 = { class: "col-11 col-md-7 col-xl-5 screenshot-text-container" }
const _hoisted_39 = { class: "screenshot-text-wrapper-left" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h2", { class: "info-icon-header" }, "Featured by App Store", -1)
const _hoisted_41 = { class: "info-icon-text" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Featured in the ")
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" section of the Apple App Store in 6 countries since 2020. ")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("MADE FOR ")
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<div class=\"row justify-content-center linkbadge-wrapper\"><a class=\"col-11 col-sm-7 col-md-6 col-lg-4 col-xxl-3\" href=\"https://play.google.com/store/apps/details?id=at.seemayr.bigtimer\" target=\"_blank\"><img class=\"linkbadge\" src=\"" + _imports_1 + "\"></a><a class=\"col-11 col-sm-7 col-md-6 col-lg-4 col-xxl-3\" href=\"https://apps.apple.com/us/app/big-timer-interval-clock/id1522536309?platform=iphone\" target=\"_blank\"><img class=\"linkbadge\" src=\"" + _imports_0 + "\"></a></div><div class=\"row justify-content-center linkbadge-wrapper\"><p class=\"disclaimer\"> It&#39;s free :)<br> Written in <span class=\"disclaimer-highlight\">Android Jetpack Compose</span> and <span class=\"disclaimer-highlight\">SwiftUI.</span></p></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_Transition, { mode: "out-in" }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("p", {
              class: "header-text",
              id: "keyword-info",
              style: _normalizeStyle(_ctx.headerColor),
              key: _ctx.headerindex
            }, _toDisplayString(_ctx.caption), 5))
          ]),
          _: 1
        }),
        _createVNode(_Transition, { mode: "out-in" }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("p", {
              class: "header-text",
              id: "keyword",
              style: _normalizeStyle(_ctx.headerColor),
              key: _ctx.headerindex
            }, _toDisplayString(_ctx.header), 5))
          ]),
          _: 1
        }),
        _hoisted_4
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h2", {
                class: "screenshot-text-header",
                style: _normalizeStyle(_ctx.randomTextGradient())
              }, "Bold.", 4),
              _createElementVNode("p", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _hoisted_14,
                _createElementVNode("span", {
                  style: _normalizeStyle(_ctx.randomTextColor())
                }, "most modern", 4),
                _hoisted_15
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("h2", {
                class: "screenshot-text-header",
                style: _normalizeStyle(_ctx.randomTextGradient())
              }, _hoisted_22, 4),
              _createElementVNode("p", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("span", {
                  style: _normalizeStyle(_ctx.randomTextColor())
                }, "complex", 4),
                _hoisted_25,
                _hoisted_26,
                _hoisted_27,
                _createElementVNode("span", {
                  style: _normalizeStyle(_ctx.randomTextColor())
                }, "or many", 4),
                _hoisted_28,
                _hoisted_29,
                _hoisted_30,
                _createElementVNode("span", {
                  style: _normalizeStyle(_ctx.randomTextColor())
                }, "every detail", 4),
                _hoisted_31,
                _hoisted_32,
                _hoisted_33,
                _hoisted_34
              ])
            ])
          ]),
          _hoisted_35
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("p", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("span", {
                  style: _normalizeStyle(_ctx.randomTextGradient())
                }, "Apps we love", 4),
                _hoisted_43
              ])
            ])
          ])
        ]),
        _createVNode(_Transition, { mode: "out-in" }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("p", {
              id: "keyword-pulser",
              key: _ctx.keywordindex
            }, [
              _hoisted_44,
              _createElementVNode("span", {
                style: _normalizeStyle(_ctx.randomTextGradient())
              }, _toDisplayString(_ctx.keyword), 5)
            ]))
          ]),
          _: 1
        }),
        _hoisted_45
      ])
    ])
  ], 64))
}